/**
 * locale store - 화면 언어 상태. localStorage persist 는 서버 응답 전 깜빡임을 막는 표시용 캐시다.
 * 진실은 서버(FRM_USER_PREF -> FRM_COMPANY_I18N)이고 체인 판정은 composables/useLocale 한 곳에서 한다.
 */
import { defineStore } from 'pinia';
import { DEFAULT_LOCALE, SUPPORTED_LOCALES, setI18nLocale } from '@/locales';

export const useLocaleStore = defineStore('locale', {
  state: () => ({
    locale: DEFAULT_LOCALE,
  }),
  getters: {
    options: () => SUPPORTED_LOCALES,
  },
  actions: {
    /** 확정 - 상태 + persist + 화면 적용. */
    async setLocale(locale) {
      const next = await setI18nLocale(locale);
      this.locale = next;
      return next;
    },
    /** 미리보기 - 화면만 바꾸고 저장하지 않는다(저장 전 선택이 기기에 남지 않게). */
    async previewLocale(locale) {
      return setI18nLocale(locale);
    },
    /** 앱 mount 직전 1회 - persist 로 복원된 언어를 적용한다. */
    async applyCurrent() {
      return setI18nLocale(this.locale);
    },
  },
  persist: {
    storage: localStorage,
    key: 'insait.locale',
  },
});
